import React from "react";
import { Modal } from "@components";
import "./styles.css";

function AcceptTermsModal({ handleIniciarSessao }) {
  return (
    <>
      <Modal
        idModal="modal-one"
        titulo="Termo de Consentimento da Videoconferência"
        variant="accept-terms"
      >
        <div className="accept-terms-container">
          <h1>Termo de Consentimento</h1>
          <div className="accept-terms-content">
            <span>
              Para dar continuidade ao seu atendimento, necessitamos que você
              consinta com os seguintes termos:
            </span>

            <ul className="accept-terms-list">
              <li>
                Esta videoconferência será gravada e a gravação será integrada
                ao seu dossiê eletrônico;
              </li>

              <li>
                Seus dados pessoais serão tratados conforme a{" "}
                <span className="text-highlight">LGPD;</span>
              </li>
              <li>Serão coletados imagem, voz, documentos e biometria;</li>
              <li>A finalidade é a validação do certificado digital;</li>
              <li>
                Seus dados poderão ser verificados junto às bases oficiais
                nacionais e ao <span className="text-highlight">PSBio</span>
              </li>
              <li>
                As informações serão armazenadas com segurança pela{" "}
                <span className="text-highlight">
                  Autoridade Certificadora.
                </span>
              </li>
            </ul>
          </div>

          <div className="accept-terms-actions">
            <a className="btn btn-recusar" href="#root">
              Recusar
            </a>
            <a
              className="btn btn-confirmar"
              href="#root"
              onClick={handleIniciarSessao}
            >
              Confirmar
            </a>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default AcceptTermsModal;
